// src/layout/Breadcrumbs.tsx
import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";
import { LayoutContext } from "./context/layoutcontext";
import { MenuRoutes, generateBreadcrumbs, findMenuHierarchy } from "../user-menu/menu";

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const { breadcrumbModel, onBreadcrumbClick, setNavigationModule } = useContext(LayoutContext);
  const { menuData } = MenuRoutes();

  // Find which module the current page belongs to
  const currentHierarchy = useMemo(() => {
    return findMenuHierarchy(menuData, location.pathname);
  }, [menuData, location.pathname]);

  // Generate dynamic breadcrumbs from menu structure
  const dynamicBreadcrumbs = useMemo(() => {
    if (!menuData || menuData.length === 0) return [];
    return generateBreadcrumbs(menuData, location.pathname);
  }, [menuData, location.pathname]);

  const home = {
    icon: "pi pi-home",
    command: () => (window.location.href = "/"),
  };

  // Handler to open menu with module
  const handleBreadcrumbClick = () => {
    if (currentHierarchy.module && setNavigationModule) {
      setNavigationModule(currentHierarchy.module.moduleId);
    }
  };

  // Use dynamic breadcrumbs if available, otherwise use context breadcrumbModel
  let model;

  if (dynamicBreadcrumbs && dynamicBreadcrumbs.length > 0) {
    // Use dynamic breadcrumbs from menu structure
    model = dynamicBreadcrumbs.map((item, index) => ({
      label: item.label,
      command: index < dynamicBreadcrumbs.length - 1 ? handleBreadcrumbClick : undefined,
      template: (templateItem: any) =>
        index === dynamicBreadcrumbs.length - 1 ? (
          <span className="p-menuitem-text">{templateItem.label}</span>
        ) : (
          <a
            className="p-menuitem-text"
            style={{ cursor: 'pointer', color: '#00923f' }}
            onClick={handleBreadcrumbClick}
          >
            {templateItem.label}
          </a>
        ),
    }));
  } else if (breadcrumbModel && breadcrumbModel.length > 0) {
    // Use breadcrumbModel from context (legacy support)
    model = breadcrumbModel.map((item: any, index: number) => ({
      ...item,
      command: () => {
        // Call the breadcrumb click callback if provided
        if (onBreadcrumbClick && index < breadcrumbModel.length - 1) {
          onBreadcrumbClick(item.label);
        }
      },
      template: (item: any) =>
        index === breadcrumbModel.length - 1 ? (
          <span className="p-menuitem-text">{item.label}</span>
        ) : (
          <a
            className="p-menuitem-text"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              if (onBreadcrumbClick) {
                onBreadcrumbClick(item.label);
              }
            }}
          >
            {item.label}
          </a>
        ),
    }));
  }

  if (!model || model.length === 0) {
    return null;
  }

  return (
    <div
      className="breadcrumb-container"
      style={{
        marginTop: "5.5rem", // Desktop topbar height
        padding: "0.5rem 1.5rem"
      }}
    >
      <BreadCrumb model={model} home={home} />
    </div>
  );
};

export default Breadcrumbs;